module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAUVJREFUSA1j+A8FFn7tMOZ/lgvXnjCAwJ8//xhgbBYDLRmwIAsLEwOMzQDSo2JTDdcKYsC1w7SCtYFk0FWCtYMkQAAkiewKiCiEZARJgo0hRCDrwmci3Ool605iuAtmCBMh20DycO8+ef4erB7F21ATiPMAzF6K3cQIMglqNZxauv4UQ0PfJjBfRIiH4fjGCrgcPgZRoYDPAGQ54gICWQceNnVdNnjDDJvLVG1r4CFz+3ALnE2IQdUwG7yGwXMlrvDAlktxqR28iZaqEYC11BhNZ7hSBVgca5hh04Fc+iLLk1ISI+sjxKZqyiBkGSnyow4jJbRAaqla/JBqOT71o1GJL3SwyTGev/IIo2GGTeHOg9cY5iw/jCElwMfFMLsrFkOcUgEWA21Zosy4eus5VnXgbgGRZmA1AIfgaBrDETA4hQdtiAEAtHIcYRJAlwcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Suomi.png
// module id = 490
// module chunks = 7